import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ItemResponseDto } from "../../shared/dtos/item/ItemResponseDto";
import { ItemImportReportDto } from "../../shared/dtos/item/ItemImportReportDto";
import { ItemSyncReportDto } from "../../shared/dtos/item/ItemSyncReportDto";
import {
  getInitialCrudState,
  generateCrudReducers,
} from "../utils/crudFactory";

const initialState = {
  ...getInitialCrudState<ItemResponseDto>(),
  importReport: null as ItemImportReportDto | null,
  syncReport: null as ItemSyncReportDto | null,
  loadingImport: false,
  loadingSync: false,
  loadingArchive: false,
  errorImport: null as string | null,
  errorSync: null as string | null,
  errorArchive: null as string | null,
};

export const itemSlice = createSlice({
  name: "item",
  initialState,
  reducers: {
    ...generateCrudReducers<ItemResponseDto>(),
    setLoadingImport(state) {
      state.loadingImport = true;
      state.errorImport = null;
    },
    setLoadingSync(state) {
      state.loadingSync = true;
      state.errorSync = null;
    },
    setLoadingArchive(state) {
      state.loadingArchive = true;
      state.errorArchive = null;
    },
    setErrorImport(state, action: PayloadAction<string | null>) {
      state.loadingImport = false;
      state.errorImport = action.payload;
    },
    setErrorSync(state, action: PayloadAction<string | null>) {
      state.loadingSync = false;
      state.errorSync = action.payload;
    },
    setErrorArchive(state, action: PayloadAction<string | null>) {
      state.loadingArchive = false;
      state.errorArchive = action.payload;
    },
    importItemsSuccess(state, action: PayloadAction<ItemImportReportDto>) {
      state.loadingImport = false;
      state.importReport = action.payload;
    },
    syncItemsSuccess(state, action: PayloadAction<ItemSyncReportDto>) {
      state.loadingSync = false;
      state.syncReport = action.payload;
    },
    archiveItemSuccess(state, action: PayloadAction<string>) {
      state.loadingArchive = false;
      if (state.item && state.item.id === action.payload)
        state.item.archived = !state.item.archived;
      state.items = state.items.map((i) =>
        i.id === action.payload ? { ...i, archived: !i.archived } : i,
      );
    },
    resetReports(state) {
      state.importReport = null;
      state.syncReport = null;
    },
  },
});

export const itemActions = itemSlice.actions;
export default itemSlice.reducer;
